import { useState } from "react";
import { useScrollFade } from "./hooks/useScrollFade";
import "./styles/global.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ServiceModal from "./components/ServiceModal";

import Hero from "./sections/Hero";
import Services from "./sections/Services";
import Packages from "./sections/Packages";
import BuildYourOwn from "./sections/BuildYourOwn";
import Gallery from "./sections/Gallery";
import HowItWorks from "./sections/HowItWorks";
import Testimonials from "./sections/Testimonials";
import Contact from "./sections/Contact";
import AdminDashboard from "./sections/AdminDashboard";

// Simple client-side routing — no react-router needed
const isAdmin = window.location.pathname === "/admin";

function MainSite() {
  const [activeService, setActiveService] = useState(null);
  useScrollFade();

  return (
    <>
      <Navbar />
      <Hero />
      <Services onServiceClick={setActiveService} />
      <Packages />
      <BuildYourOwn />
      <Gallery />
      <HowItWorks />
      <Testimonials />
      <Contact />
      <Footer />
      <ServiceModal service={activeService} onClose={() => setActiveService(null)} />
    </>
  );
}

export default function App() {
  if (isAdmin) return <AdminDashboard />;
  return <MainSite />;
}